{
  "eyebrow": "Confirmă-ți planul",
  "title": "Verifică și configurează.",
  "sub": "Poți schimba ciclul de facturare sau planul din linia ta de produs oricând din panoul de administrare. Trecerea între Time și Project se stabilește împreună cu echipa noastră.",
  "yourPlan": "Planul tău",
  "changePlan": "Schimbă planul",
  "billing": "Ciclu de facturare",
  "billingMonthLabel": "Plată lunară",
  "billingMonthDesc": "Flexibil. Anulează oricând.",
  "billingYearLabel": "Plată anuală",
  "billingYearDesc": "15% reducere. Facturat o dată pe an.",
  "addons": "Add-on-uri",
  "addon": {
    "ssec": "Asigurări sociale (check-in/out@work)",
    "ssecDesc": "Doar Belgia — declarație Dimona automată.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS live pentru vehiculele companiei. +4,80 €/vehicul/lună.",
    "vehicles": "Vehicule"
  },
  "users": {
    "title": "De câți utilizatori ai nevoie?",
    "help": "Fiecare persoană care utilizează Done-it contează ca un utilizator, inclusiv administratorii și angajații.",
    "active": "utilizatori"
  },
  "estimate": "Cost lunar estimat",
  "estimateNote": "Fără TVA. Plătiți pentru numărul de utilizatori setat aici și îl puteți modifica ulterior.",
  "estimateUnavailable": "Catalog de prețuri indisponibil. Reîncearcă pentru a încărca cele mai noi prețuri."
}
